import React from 'react'

import HomeItem from '../container/HomeItem';
import SkillsItem from '../container/SkillsItem';


const Home = () => {
  return (
    <div>
        
        <HomeItem/>
        <SkillsItem/>
      
        
       
    </div>
  )
}

export default Home